module.exports = __webpack_public_path__ + "img/icon-tarjeta-outline.94e1da08.svg";